import { DropdownChangeHandler } from '../../dropdownChangeHandlers'
import { syncFastRackHiddenClampLandscapeWarning } from './FastRack'
import { getLandscapeGridNames } from './FastRackInputForm'

const handlePestNone: DropdownChangeHandler = (system, _translate) => {
  if (system.integration_json?.fastRack) {
    const updated = { ...system.integration_json.fastRack }
    delete updated.fenceHeight
    delete updated.fenceAttachment
    const updatedJson = { ...system.integration_json, fastRack: updated }
    window.editor.execute(new window.SetValueCommand(system, 'integration_json', updatedJson))
  }
}

const handlePestEdgeTrim: DropdownChangeHandler = (system, translate) => {
  handlePestNone(system, translate)
}

const handleHiddenClampYes: DropdownChangeHandler = (system, _translate) => {
  const landscapeNames = getLandscapeGridNames(system)
  syncFastRackHiddenClampLandscapeWarning(system.uuid, 'yes', landscapeNames)
}

const handleHiddenClampNo: DropdownChangeHandler = (system, _translate) => {
  syncFastRackHiddenClampLandscapeWarning(system.uuid, 'no', [])
}

export const fastRackDropdownHandlers: Record<string, Record<string, DropdownChangeHandler>> = {
  pestProtection: {
    none: handlePestNone,
    edgeTrim: handlePestEdgeTrim,
  },
  hiddenClamp: {
    yes: handleHiddenClampYes,
    no: handleHiddenClampNo,
  },
}
